import styled from "@emotion/styled";

//  container
export const Wrapper = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: 70% 30%;
  align-items: flex-start;
`;

export const MainContainer = styled.div`
  display: grid;
  padding: 3rem;
`;

// header Container
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

// button
export const Button = styled.button`
  padding: 0.8rem 38px;
  border: 0.5px solid #000;
  border-radius: 40px;
  background-color: transparent;
  color: #080808;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
`;

// Client container
export const ClientContainer = styled.div`
  display: grid;
  align-items: start;
`;

export const HeaderClient = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin: 4rem 0;
`;

export const ClientInfo = styled.div`
  display: grid;
`;

export const H1 = styled.h1`
  margin-bottom: 1rem;
`;
export const Span = styled.span``;

export const ProgressContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 2rem;
  margin-bottom: 2rem;
`;

// Folder container
export const FolderContainer = styled.div`
  display: grid;
  border-top: 1px solid #e4e4e4;
  padding: 3rem;
  height: 100%;
  align-items: start;
`;

export const TasksContainer = styled.div``;
export const Tasks = styled.div`
  display: grid;
  margin: 0.7rem 0;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  font-size: 12px;
  font-weight: 400;
`;
export const SingleTaskContainer = styled.div`
  display: grid;
  margin: 0.7rem 0;
  grid-template-columns: auto 1fr;
  gap: 0.5rem;
  font-size: 12px;
  font-weight: 400;
`;

export const displayColor = styled.span`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: ${(p) => (p.isTaskDone ? "yellow" : "red")};
`;
export const Task = styled.div``;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

